<template>
    <div>
        <el-form :inline="true">
            <el-form-item label="交易对">
                <coin-select @value="setCoin"></coin-select>
            </el-form-item>
            <el-form-item>/</el-form-item>
            <el-form-item>
                <coin-select @value="setAnchor"></coin-select>
            </el-form-item>
            <el-form-item></el-form-item>
            <el-form-item label="状态">
                <el-select v-model="queryCondition.isActivated" placeholder="全部">
                    <el-option v-for="item in usable" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="querySubmit">搜索</el-button>
                <el-button type="primary" @click="opType = 'insert',showEdit = true">添加</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="quotationList">
            <el-table-column prop="tradePair" label="目标交易对"></el-table-column>
            <el-table-column label="时间">
                <template slot-scope="scope">
                    {{scope.row.tatsWithinPeriod >= 60 ? scope.row.tatsWithinPeriod / 60 + 'hours' : scope.row.tatsWithinPeriod + "min"}}
                </template>
            </el-table-column>
            <el-table-column label="涨幅">
                <template slot-scope="scope">
                    {{scope.row.risePercentageThreshold ? scope.row.risePercentageThreshold + '%' : '--'}}
                </template>
            </el-table-column>
            <el-table-column label="跌幅">
                <template slot-scope="scope">
                    {{scope.row.fallPercentageThreshold ? scope.row.fallPercentageThreshold + '%' : '--'}}
                </template>
            </el-table-column>
            <el-table-column label="推送间隔">
                <template slot-scope="scope">
                    {{scope.row.intervalTime <= 30 ? scope.row.intervalTime + 'min': '24hours'}}
                </template>
            </el-table-column>
            <el-table-column label="是否开启">
                <template slot-scope="scope">
                    <el-switch active-color="#13ce66" @change="handleStatusChange(scope.$index,scope.row.id, $event)" v-model="scope.row.isActivated">></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <div v-if="!scope.row.isActivated">
                        <el-button type="text" @click="handleAlter(scope.row)">修改</el-button>
                        <el-button type="text" @click="handleRemove(scope.row.id)">删除</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :visible.sync= "showEdit" @close="closeDialog">
            <template slot="title">
                <span style="font-weight: bolder;font-size: 17px;">行情自动推送编辑</span>
            </template>
            <el-form label-width="150px">
                <el-form-item label="目标交易对">
                    <el-row v-if="opType === 'insert'">
                        <el-col :span="4">
                            <coin-select :coinType = "editInfo.coinType" @value="val => editInfo.coinType = val"></coin-select>
                        </el-col>
                        <el-col :span="1" style="text-align: center">/</el-col>
                        <el-col :span="8">
                            <coin-select :coinType = "editInfo.anchorType" @value="val => editInfo.anchorType = val"></coin-select>
                        </el-col>
                    </el-row>
                    <span v-if="opType === 'update'">{{editInfo.tradePair}}</span>
                </el-form-item>
                <el-form-item label="涨跌幅时间">
                    <el-row>
                        <el-col :span="4">
                           <el-select v-model="editTime">
                               <el-option  v-for="item in times" :key="item" :label="item" :value="item"></el-option>
                           </el-select>
                        </el-col>
                        <el-col :span="1" style="text-align: center">/</el-col>
                        <el-col :span="8">
                            <el-select v-model="editInfo.unit" @change="unitChange">
                                <el-option v-for="item in units" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="涨幅大于">
                    <el-input-number controls-position="right" v-model="editInfo.risePercentageThreshold" placeholder="请输入数字" style="width: 200px" :min="1" :max="100"></el-input-number>%
                </el-form-item>
                <el-form-item label="跌幅大于">
                    <el-input-number controls-position="right" v-model="editInfo.fallPercentageThreshold" placeholder="请输入数字" style="width: 200px" :min="1" :max="100"></el-input-number>%
                </el-form-item>
                <el-form-item label="推送间隔">
                    <el-radio-group v-model="editInfo.intervalTime">
                        <el-radio :label="10" v-if="editTime !== 24">10分钟</el-radio>
                        <el-radio :label="30" v-if="editTime !== 24">30分钟</el-radio>
                        <el-radio :label="1440" v-if="editTime === 24">24小时</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否开启">
                    <el-switch v-model="editInfo.isActivated" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="submitEdit">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import coinSelect from '../../../../components/coinSelect';
    import {mapState, mapActions} from 'vuex';
    import api from '../api';
    export default {
        name: "quotation",
        components:{coinSelect},
        computed:{...mapState('pushSetting',['infoList'])},
        data(){
         return{
             queryCondition:{
                 coinType:'',
                 anchorType:'',
                 isActivated:'',
             },
             usable:[{code:null,desc:'全部'},{code:true,desc:'开启'},{code:false,desc:'关闭'}],
             showEdit:false,
             editInfo:{
                 time:5,unit:'min',intervalTime:0,isActivated:false
             },
             editTime: 5,
             times:[5,15,30],
             units:['min','hours'],
             opType:'',
             quotationList:[]
         }
        },
        methods:{
            ...mapActions('pushSetting',['queryQuotationPushConf']),
            setCoin(val){
              this.queryCondition.coinType = val;
            },
            setAnchor(val) {
                this.queryCondition.anchorType = val;
            },
            querySubmit() {
                this.queryCondition.tradePair = this.queryCondition.coinType + '_' + this.queryCondition.anchorType;
                this.queryQuotationPushConf(this.queryCondition);
            },
            handleStatusChange(index,id,status){
                api.updateActivatedById({id:id,isActivated:status}).catch( () =>{
                    this.quotationList[index].isActivated = false;
                });
            },
            handleRemove(id) {
                this.$confirm('确认删除操作该配置,是否继续?','提示',{confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'})
                    .then(() => {
                        api.removeQuotationPushConf({id:id}).then(() => {
                            this.$message.success('删除成功');
                            this.queryQuotationPushConf({});
                        })
                    })
            },
            closeDialog(){
                this.editInfo.coinType = '';
                this.editInfo.anchorType = '';
                this.showEdit = false;
                this.editTime = 5;
                this.editInfo ={time:5,unit:'min',intervalTime:0,isActivated:false};
            },
            handleAlter(row){
                this.opType = 'update';
                this.editInfo = JSON.parse(JSON.stringify(row));
                let tradPair = this.editInfo.tradePair;
                this.editInfo.coinType = tradPair.substring(0,tradPair.indexOf('_'));
                this.editInfo.anchorType = tradPair.substring(tradPair.indexOf('_') + 1);
                if (this.editInfo.tatsWithinPeriod >= 60) {
                    this.editTime = this.editInfo.tatsWithinPeriod / 60;
                    this.editInfo.unit = 'hours';
                    this.times = [1,24];
                }else {
                    this.editTime = this.editInfo.tatsWithinPeriod;
                    this.editInfo.unit = 'min';
                    this.times = [5,15,30];
                }
                this.showEdit = true;
            },
            unitChange(){
                if (this.editInfo.unit === 'min') {
                    this.times = [5,15,30];
                    this.editTime = 5;
                }
                if (this.editInfo.unit === 'hours') {
                    this.times = [1,24];
                    this.editTime = 1;
                }
            },
            submitEdit() {
                if (this.editInfo.coinType === '' || this.editInfo.coinType === undefined || this.editInfo.anchorType === '' || this.editInfo.anchorType === undefined) {
                    this.$message.error("目标交易对信息不完整");
                    return;
                }
                if ((this.editInfo.risePercentageThreshold === '' || this.editInfo.risePercentageThreshold === undefined) && (this.editInfo.fallPercentageThreshold === '' ||  this.editInfo.fallPercentageThreshold === undefined)) {
                    this.$message.error("涨跌幅不能同时为空");
                    return;
                }
                this.editInfo.tradePair = this.editInfo.coinType + '_' + this.editInfo.anchorType;
                this.editInfo.tatsWithinPeriod = this.editInfo.unit === 'min' ? this.editTime: this.editTime * 60;
                if (this.opType === 'insert') {
                   api.addQuotationPushConf(this.editInfo).then(() => {
                       this.$message.success('新增成功');
                       this.queryQuotationPushConf({});
                       this.closeDialog();
                   });
                }
                if (this.opType === 'update') {
                   api.updateQuotationPushConf(this.editInfo).then(() =>{
                       this.$message.success('修改成功');
                       this.queryQuotationPushConf({});
                       this.closeDialog();
                   })
                }
            },
        },
        watch:{
            infoList(val) {
                this.quotationList = JSON.parse(JSON.stringify(val));
            }
        }
    }
</script>

<style scoped>

</style>